module.exports = __webpack_public_path__ + "img/15t.5df9dc85.jpg";